export const REMOVE_DRIVER_JSON_MAP = {
  firstName: 'First Name',
  lastName: 'Last Name',
  policyNumber: 'Policy Number',
  phoneNumber: 'Phone Number',
  streetAddress: 'Street Address',
  zipCode: 'Zip Code',
  emailAddress: 'Email Address',
  removeDriverInfo: {
    firstName: 'Remove Driver First Name',
    lastName: 'Remove Driver Last Name',
    dateOfBirth: 'Remove Driver Date Of Birth',
    maritalStatus: 'Remove Driver Marital Status',
    relationship: 'Remove Driver Relationship to the Policyholder',
    isInSameHousehold: 'Is Remove Driver Resides in same household?',
    streetAddress: 'Street Address',
    apt: 'Apartment#',
    city: 'City',
    state: 'State',
    zipCode: 'Zip Code',
    reason: 'Reason for Removing Driver',
    isLicenseValid: 'Does the driver have a valid license?',
    licenseNumber: "Driver's License Number",
    otherOption: 'Reason for Driver No longer drives policy vehicles',
    explanation: "Please explan why Remove Driver doesn't have a valid license?",
    effectDate: 'What date would you like this change to go into effect?'
  }
}
